import * as React from "react"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { FormMessage } from "@/components/ui/form"
import { cn } from "@/lib/utils"

export interface LeadTextareaFieldProps extends React.ComponentProps<"textarea"> {
 label?: string
 error?: string
 hint?: string
 required?: boolean
 containerClassName?: string
}

export const LeadTextareaField = React.forwardRef<HTMLTextAreaElement, LeadTextareaFieldProps>(
 (
 {
 label,
 error,
 hint,
 required,
 containerClassName,
 className,
 id,
 ...props
 },
 ref
 ) => {
 const fieldId = id || React.useId()

 return (
 <div className={cn("space-y-2", containerClassName)}>
 {label && (
 <Label 
 htmlFor={fieldId} 
 className={required ? "after:content-['*'] after:ml-0.5 after:text-destructive" : ""}
 >
 {label}
 </Label>
 )}
 <Textarea
 ref={ref}
 id={fieldId}
 className={cn(
 error && "border-destructive focus-visible:ring-destructive",
 className
 )}
 aria-invalid={!!error}
 aria-describedby={error ? `${fieldId}-error` : hint ? `${fieldId}-hint` : undefined}
 {...props}
 />
 {hint && !error && (
 <p id={`${fieldId}-hint`} className="text-[0.8rem] text-muted-foreground">
 {hint}
 </p>
 )}
 {error && (
 <FormMessage id={`${fieldId}-error`} className="text-[0.8rem] font-medium text-destructive">
 {error}
 </FormMessage>
 )}
 </div>
 )
 }
)
LeadTextareaField.displayName = "LeadTextareaField"

